import React, { useState, Fragment } from 'react';
import {
    Label, Input, Card, Button, ModalHeader, ModalBody,
    ModalFooter, Modal, Dropdown, DropdownItem, DropdownMenu,
    UncontrolledDropdown, DropdownToggle, Badge
} from 'reactstrap';
import {
    Separator,
    Colxx,
} from '../../../../../components/common/CustomBootstrap';
import ReactDragListView from "react-drag-listview";
import { List } from "antd";
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import { API_FAQ_Collection } from '../../../../../constants/APIs';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Validation from '../../../../../components/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import FAQCollection from './FAQCollectionForm';

const FAQCollectionList = ({ match, faqCollectionList, LoadData, locale, sortFaqListByOrder }) => {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [faqId, setFaqId] = useState();
    const [isEdit, setIsEdit] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const handleDeleteToggle = () => {
        setIsDelete(!isDelete);
    }

    const handleEditToggle = () => {
        setIsEdit(!isEdit);
    }

    const handleEditClick = (id) => {
        setFaqId(id);
        handleEditToggle();
    }

    const handleDeleteClick = (id) => {
        setFaqId(id);
        handleDeleteToggle();
    }

    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${API_FAQ_Collection}/${faqId}`,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                handleDeleteToggle();
                LoadData();
            }
        });

    }

    const handleUpdate = (inputData) => {
        AxiosAPI({
            method: 'put',
            url: `${API_FAQ_Collection}/${faqId}`,
            data: inputData,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                handleEditToggle();
                LoadData();
            }
        });
    };


    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };


    const onDragEnd = (fromIndex, toIndex, type, index) => {
        if (toIndex < 0) return;
        if (type === "LIST-ITEM") {
            const categories = reorder(faqCollectionList, fromIndex, toIndex);
            var data = [];
            categories.map((item, i) => {
                data.push({
                    id: item.id,
                    displayOrder: i
                })
            });
            AxiosAPI({
                method: 'post',
                url: `${API_FAQ_Collection}/order`,
                data: { data: data },
            }).then((res) => {
                LoadData();
            }).catch((err) => {
                console.log('err', err);
            });
        } else return new Error("NOT A VALID LIST");
    };

    return (
        <Fragment>
            {(faqCollectionList !== undefined
                && faqCollectionList.length > 0) && <ReactDragListView
                    nodeSelector=".ant-list.draggable"
                    lineClassName="dragLine"
                    onDragEnd={(fromIndex, toIndex) =>
                        onDragEnd(fromIndex, toIndex, "LIST-ITEM")
                    }
                >
                    {sortFaqListByOrder.map((item, index) =>
                        <List key={index} className="draggable">
                            <div className="d-flex flex-row mb-3">
                                <span className="draggable item-center "><a href="#"><i className="simple-icon-cursor-move"></i></a></span>
                                <Colxx xxs="12">
                                    <Card className="d-flex flex-row mb-0" style={{ borderRadius: '10px' }}>
                                        <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center mt-0" >
                                                <p className="mb-1 ml-5  text-small w-40 w-sm-100">
                                                    <b>{item.title}</b>
                                                </p>
                                                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                                                    {item.status !== 'Active' ? <span style={{ color: 'red' }}>Inactive</span> :
                                                        <span style={{ color: 'green' }}>Active</span>}
                                                </p>
                                                {/* <p className="mb-1 text-muted text-small w-20 w-sm-100">
                                                    {moment(item.date).format('MMM DD, YYYY hh:mm')}
                                                </p> */}
                                                <div className="mb-1 w-10 w-sm-100">
                                                    <FontAwesomeIcon
                                                        icon={faEdit}
                                                        color="#90caf9"
                                                        cursor="pointer"
                                                        onClick={() => handleEditClick(item.id)}
                                                    />
                                                    <Fragment>
                                                        <b> | </b>
                                                        <FontAwesomeIcon
                                                            icon={faTrashAlt}
                                                            style={{ color: 'var(--theme-color-1)' }}
                                                            cursor="pointer"
                                                            onClick={() => handleDeleteClick(item.id)}
                                                        />
                                                    </Fragment>


                                                    {/* <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                                                    <DropdownToggle caret color="outline-dark" size="xs">
                                                        more
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <DropdownItem
                                                            key="edit"
                                                            onClick={() => handleEditClick(item.id)}
                                                        >
                                                            View Details
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            key="danger"
                                                            onClick={() => handleDeleteClick(item.id)}
                                                        >
                                                            Delete Collection
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown> */}
                                                </div>

                                            </div>
                                        </div>
                                    </Card>
                                </Colxx>
                            </div>
                        </List>
                    )
                    }
                </ReactDragListView>}
            {
                (isEdit && faqId !== undefined) &&
                <FAQCollection label={"Update Collection"} id={faqId} toggle={handleEditToggle} submit={handleUpdate}
                    visible={isEdit} ></FAQCollection>
            }

            {
                (isDelete && faqId !== undefined) &&
                <Modal isOpen={isDelete} toggle={handleDeleteToggle} style={{ maxWidth: '600px' }}>
                    <ModalHeader toggle={handleDeleteToggle}>
                        Delete Collection
                    </ModalHeader>
                    <ModalBody>
                        <h6 className='mb-3'>Are you sure you want to delete ?</h6>
                    </ModalBody>
                    <ModalFooter>
                        <Button color='danger' onClick={handleDelete}>Delete</Button>
                        <Button color='secondary' onClick={handleDeleteToggle}>Back</Button>
                    </ModalFooter>
                </Modal>
            }
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment >
    );
};

const mapStateToProps = ({ settings }) => {
    const { locale } = settings;
    return {
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(FAQCollectionList));
